import DownloadIcon from '@mui/icons-material/Download'
import { Tooltip, Typography } from '@mui/material'
import { currentTheme } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { ITypography } from './EFTypography.model'
import classNames from 'classnames/bind'
import styles from './EFTypography.module.scss'
import { useEffect, useRef, useState } from 'react'

const cx = classNames.bind(styles)

export function EFTypography(props: ITypography) {
  const { color = 'primary', children, isDownloadLink, disabled, ...otherProps } = props
  const theme = useAppSelector(currentTheme)

  const ref = useRef<HTMLDivElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);
  const toolTipPlacement_BottomStart = "bottom-start"

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsOverflow(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  return (
    <Tooltip title={children} placement={toolTipPlacement_BottomStart} arrow disableHoverListener={!isOverflow}>
      <Typography
        {...otherProps}
        className={cx(`ef-text`, color, theme, props.className ?? '',  disabled ? 'disabled' : '')}
        onClick={(e) => {
          if (disabled) {
            e.stopPropagation();
            return;
          }
          if (otherProps.onClick) {
            otherProps.onClick(e);
          }
        }}
        ref={ref}
      >
        {children}
        {isDownloadLink && <DownloadIcon sx={{ height: '1.3rem' }} />}
      </Typography>
    </Tooltip>
  )
}
